import { cn } from '@shared/lib/cn';

import { LISTBOX_BOX_CLASS, LISTBOX_SKELETON_BAR_CLASS } from './listbox.constant';

export interface ListboxSkeletonProps {
  className?: string;
}

/** Listbox 의 status=init — 목록 상자 안에 막대 3개(줄 높이 36) */
export function ListboxSkeleton({ className }: ListboxSkeletonProps) {
  return (
    <div
      aria-hidden="true"
      data-status="init"
      className={cn('skeleton-pulse', LISTBOX_BOX_CLASS, className)}
    >
      {LISTBOX_SKELETON_BAR_CLASS.map((width) => (
        <span key={width} className="flex items-center p-3">
          <span className={cn('h-3 max-w-full rounded-full bg-bg-pressed', width)} />
        </span>
      ))}
    </div>
  );
}
